module.exports = __webpack_public_path__ + "img/copertina_studente.df4fb9fc.jpg";